import { Inject, Pipe, PipeTransform } from '@angular/core';
import { find, isString } from 'lodash';

import {
  CobMeta,
  CobMetaService,
  TEMP_COB_DATA,
  TempCobMeta,
} from '@lockton-apps/shared/util/constants';

@Pipe({
  name: 'cobMeta',
  standalone: true,
})
export class CobMetaPipe implements PipeTransform {
  constructor(
    private cobMetaService: CobMetaService,
    @Inject(TEMP_COB_DATA) private tempCobData: TempCobMeta[] = [],
  ) {}

  transform(value: number | string): CobMeta {
    const meta: CobMeta | undefined = isString(value)
      ? this.cobMetaService.getClassOfBusinessMetaById(value)
      : this.cobMetaService.getClassOfBusinessMeta(value);

    const defaultMeta: CobMeta = {
      id: 'unknown',
      title:
        (find(this.tempCobData, { id: value }) as TempCobMeta)?.name ||
        'Unnamed Product',
      icon: 'product_thin',
      color: 'grayMedium',
      type: 'policy',
    };

    return meta || defaultMeta;
  }
}
